import * as actionTypes from "../actionTypes";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import {callAllWifiPackages, checkErrorResponse, receptionAllBuildingHandler} from "../Reception_SheduleMeetingActions";
import {notifyMessage} from "../../../const/Common/CommonFunc";
import * as config from "../../../const/config/config";
import axios_authentication from "../../../axios/axios_authorization";
import * as qs from "qs";
import {callAllCount} from "../Reception_VisitorCountActions";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";

export const storeHostMobileHandler = (data) => {
  return {type: actionTypes.STORE_HOST_MOBILE, value: data}
}

export const removeHostMobileHandler = (data) => {
  return {type: actionTypes.REMOVE_HOST_MOBILE, value: data}
}

export const storeHostEntityHandler = (data) => {
  return {type: actionTypes.STORE_HOST_ENTITY, value: data}
}

export const removeHostEntityHandler = (data) => {
  return {type: actionTypes.REMOVE_HOST_ENTITY, value: data}
}

export const hostAllBuildingHandler = (data) => {

  return {
    type: actionTypes.ALL_BUILDINGS,
    value: data
  }
};

export const setMeetingHost = (data) => {

  return {
    type: actionTypes.SET_HOST_CURRENT_MEETING,
    value: data
  }
};

export const removeMeetingHost = () => {

  return {
    type: actionTypes.REMOVE_HOST_CURRENT_MEETING,
    value: ""
  }
};

export const callAllBuildingsForHost = (usr_obj) => {
  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    // "Authorization": "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJjdF9rYXZpbmR1Iiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXSwiZXhwIjoxNTk2MTA1MjYxLCJ1c2VyIjp7InVzZXJJZCI6MzUsInVzZXJOYW1lIjoiY3Rfa2F2aW5kdSIsImZ1bGxOYW1lIjoiS2F2aW5kdSBBa2FzaCBTYW1hcmFzaW5naGUiLCJlbWFpbCI6Im5ld3RlY2hzb2lsZGVyQGdtYWlsLmNvbSIsInN0YXR1cyI6MSwidXNlclJvbGVzIjoiUkVDRVBUSU9OIiwiY29ycG9yYXRlcyI6W3siY29ycG9yYXRlSWQiOjEsImNvcnBvcmF0ZUNvZGUiOiJDMDAxIiwiY29ycG9yYXRlTmFtZSI6IkNleWVudHJhIFRlY2hub2xvZ2llcyJ9XSwic2VydmljZXMiOlt7InNlcnZpY2VJZCI6MSwic2VydmljZU5hbWUiOiJQYXJrVGFnIFNlcnZpY2UifSx7InNlcnZpY2VJZCI6Miwic2VydmljZU5hbWUiOiJWaXNpdG9yVGFnIFNlcnZpY2UifV19LCJhdXRob3JpdGllcyI6WyJST0xFX1JFQ0VQVElPTiJdLCJqdGkiOiJlNWE3NTk3MC00Nzc2LTQxOTctYmQzZi1iMWFiNTk5NTIyNzAiLCJjbGllbnRfaWQiOiJjZXllbnRyYSJ9.GqJg3JLqoKt9RYNePPiyIQRTmkw329Ovt5fKyp7EqoA"
  };
  let coperateId = usr_obj.corporates[0].corporateId;
  // let coperateId = 1;

  // Get All Buildings Of Corporate
  return dispatch => {
    axiosTags.get(apiConfig.CORPORATE_BUILDINGS(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          dispatch(hostAllBuildingHandler(response.data.buildingList));
        }
      })
      .catch(error => {
        dispatch(checkErrorResponseForHost(error, usr_obj, 1));
      });
  }
};

const emptyFunction = () => {
}


export const checkErrorResponseForHost = (error, usr_obj, type) => {
  if (error !== undefined) {
    if (error.response === undefined) {
      notifyMessage("Your connection was interrupted!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    } else if (error.response.status === 401) {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic " + config.CLIENT_SECRET
      };
      let refresh_token = Cookies.get('9b8558ba3f051677daf36ebfc67f29fa');

      const data_ = {
        grant_type: "refresh_token",
        refresh_token: refresh_token
      };

      // Get Access token from refresh token
      return dispatch => {
        axios_authentication.post(apiConfig.OAUTH, qs.stringify(data_), {headers: headers})
          .then(response => {
            Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
            if (type === 1) {
              dispatch(callAllBuildingsForHost(usr_obj));
            } else if (type === 2) {
              dispatch(callAllWifiPackages(usr_obj));
            } else if (type === 3) {
              dispatch(callAllCount(usr_obj));
            }

          })
          .catch(error => {

            swal({
              title: "Your token expired! Please re-enter login credentials \n Thank you",
              icon: are_you_sure_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "warning-btn"
                }
              },
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    Cookies.remove("68a6102f6ed24899420170004a0273b8");
                    Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
                    window.location.href = "/host/login";

                    break;
                  default:
                }
              });
          });
      }
    } else if (error.response.status === 403) {
      notifyMessage("Sorry, your can't access!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    } else {
      notifyMessage("Your connection was interrupted!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    }
  } else {
    notifyMessage("Your connection was interrupted!", 1, 3);
    return dispatch => {
      dispatch(emptyFunction);
    }
  }
};

